import React from 'react';
import {message, Modal, Button, Popconfirm} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import { postFrom, config, transterQuery } from '../../axios';
import moment from 'moment';
import AuthButton from "../../components/AuthButton/AuthButton";
import {warningStatusIsMap, serviceNameIsMap, syncApiTypeIsMap, dicHouseStatus} from "../../axios/dictionaries";
import {isPlatform} from "../../utils";


export default class Page extends React.Component {

    componentDidMount() {
        this.handleSearch()
    }

    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableSelectedRows: [], //表格选中的行
            showJrApiLogModal:false,
            params: {
                tableName: "",
                status:"",
                apiType:'',
                rowId: -1,
                keyword:'',
                pageSize: 10,
            },
            inputSearchTerm: "175px", //查询条件宽度
        }
    }


    handleCheck = (isBatch, id) => { //检测是否已到账
        let apiUrl= config.API_jrWarningStatus_check;
        if(!isBatch){
            apiUrl+="?warningId="+id;
        }else{
            apiUrl=config.API_jrWarningStatusAll_check;
        }
        postFrom({ url: apiUrl }).then(res => {
            message.success('操作成功');
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }


    handleSearch = (values = {}) => {   //表单搜索/分页
        let { params, current } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });
        postFrom({ url: config.API_jrWarning_findPage, data }).then(res => {
            this.setState({ tableData: res.records, current: res.current, tableTotal: res.total, tableLoading: false })
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }
    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
        } = this.state;

        return (

            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper ">
                    <div className="search-btn-list" >
                        <AuthButton authkey="j-2-3">
                            <Popconfirm placement="top" title={"确定标记所有异常数据为已处理吗？"} onConfirm={() => { this.handleCheck(true, 0) }} okText="确定" cancelText="不了">
                                <Button className="showClickDetail" type={"danger"}>标记处理所有</Button>
                            </Popconfirm>
                        </AuthButton>
                    </div>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData()}
                        sumbit={this.handleSearch.bind(this)}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ current ,handleCheck:this.handleCheck.bind(this)})}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch.bind(this)}
                    scroll={{x: 1500}}
                />
            </PageWrap>
        )
    }

    handleSelectChange = (selectedRowKeys, selectedRows) => { //表格选中行
        this.setState({ tableSelectedRows: selectedRows });
    }
}

    const searchData = () => {
        let data = [
        {
            tagName: 'Select',
            formConfig: { name: 'status' },
            attribute: { placeholder: '请选择处理状态', style: { width: "130px" } },
            optionData: [{ title: '全部', value: '' }].concat(warningStatusIsMap), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'apiType' },
            attribute: { placeholder: '请选择接口类型', style: { width: "130px" } },
            optionData: [{ title: '全部', value: '' }].concat(syncApiTypeIsMap), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'tableName' },
            attribute: { placeholder: '请选择业务名称', style: { width: "150px" } },
            optionData: [{ title: '全部', value: '' }].concat(serviceNameIsMap), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'InputNumber',
            formConfig: { name: 'rowId' },

            attribute: { placeholder: '请输入请Id', style: { width: '150px' } },
        },
        {
            tagName: 'InputTip',
            formConfig: { name: 'keyword' },
            attribute: { placeholder: '请输入关键字', style: { width: '130px' } },
            title: `在接口返回值内模糊查询`
        },
    ];

    data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.formConfig.name === 'shortName') {
            return false;
        }
        return true;
    });

    return data;
};
const columns = ({ handleCheck, handleShowDetail  }) => [

    {
        title: '接口名称',
        dataIndex: 'apiName',
        width: 120,
        render(text, record, index) {
            return <span >
                <div>{record.apiName ? record.apiName : null}</div>
            </span>
        }
    },
    {
        title: '业务名称',
        dataIndex: 'tableName',
        width: 120,
        render(text, record, index) {
            let now = serviceNameIsMap.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '请求Id',
        dataIndex: 'rowId',
        width: 80,
        render(text, record, index) {
            return <span >
                <div>{record.rowId ? record.rowId : null}</div>
            </span>
        }
    },
    {
        title: '接口参数',
        dataIndex: 'params',
        width: 350,
        render(text, record, index) {
            return <span >
                <div>{record.params ? record.params : null}</div>
            </span>
        }
    },
    {
        title: '接口返回值',
        dataIndex: 'response',
        width: 350,
        render(text, record, index) {
            return <span >
                <div>{record.response ? record.response : null}</div>
            </span>
        }
    },
    {
        title: '创建日期',
        dataIndex: 'updateTime',
        width: 120,
        render(text, record, index) {
            return <span >
                <div>{record.updateTime ? moment(record.updateTime).format('YYYY-MM-DD HH:mm') : null}</div>
            </span>
        }
    },
    {
        title: '状态',
        dataIndex: 'status',
        width: 120,
        render(text, record, index) {
            let now = warningStatusIsMap.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '处理日期',
        dataIndex: 'processingTime',
        width: 120,
        render(text, record, index) {
            return <span >
                <div>{record.processingTime ? moment(record.processingTime).format('YYYY-MM-DD HH:mm') : null}</div>
            </span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div className="table-action">
                {/*<AuthButton authkey="j-2-2"><span className="showClickDetail" onClick={() => { handleShowDetail(record.id) }}>详情</span></AuthButton>*/}
                {
                    record.status === 1  &&
                    <React.Fragment>
                        <AuthButton authkey="j-2-2">
                            <Popconfirm placement="top" title={"确定标记已处理吗？"} onConfirm={() => { handleCheck(false, record.id) }} okText="确定" cancelText="不了">
                                <span className="showClickDetail">标记处理</span>
                            </Popconfirm>
                        </AuthButton>
                    </React.Fragment>
                }
            </div>)
        }
    }
];



// WEBPACK FOOTER //
// ./src/page/Other/WarningList.js